import colors from './colors';
export default (props: any) => {
  return {
    0: {
      shadowColor: props.colorMode === 'light' ? colors.black : colors.white,
      shadowOffset: {
        width: 0,
        height: 1,
      },
      shadowOpacity: 0.18,
      shadowRadius: 1.0,
      elevation: 1,
    },
    1: {
      shadowColor: props.colorMode === 'light' ? colors.black : colors.white,
      shadowOffset: {
        width: 0,
        height: 1,
      },
      shadowOpacity: 0.2,
      shadowRadius: 1.41,
      elevation: 2,
    },
    2: {
      shadowColor: props.colorMode === 'light' ? colors.black : colors.white,
      shadowOffset: {
        width: 0,
        height: 1,
      },
      shadowOpacity: 0.22,
      shadowRadius: 2.22,
      elevation: 3,
    },
    3: {
      shadowColor: props.colorMode === 'light' ? colors.black : colors.white,
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.23,
      shadowRadius: 2.62,
      elevation: 4,
    },
    4: {
      shadowColor: props.colorMode === 'light' ? colors.black : colors.white,
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.25,
      shadowRadius: 3.84,
      elevation: 5,
    },
    5: {
      shadowColor: props.colorMode === 'light' ? colors.black : colors.white,
      shadowOffset: {
        width: 0,
        height: 3,
      },
      shadowOpacity: 0.27,
      shadowRadius: 4.65,
      elevation: 6,
    },
    6: {
      shadowColor: props.colorMode === 'light' ? colors.black : colors.white,
      shadowOffset: {
        width: 0,
        height: 3,
      },
      shadowOpacity: 0.29,
      shadowRadius: 4.65,
      elevation: 7,
    },
    7: {
      shadowColor: props.colorMode === 'light' ? colors.black : colors.white,
      shadowOffset: {
        width: 0,
        height: 4,
      },
      shadowOpacity: 0.3,
      shadowRadius: 4.65,
      elevation: 8,
    },
    8: {
      shadowColor: props.colorMode === 'light' ? colors.black : colors.white,
      shadowOffset: {
        width: 0,
        height: 4,
      },
      shadowOpacity: 0.32,
      shadowRadius: 5.46,
      elevation: 9,
    },
    9: {
      shadowColor: props.colorMode === 'light' ? colors.black : colors.white,
      shadowOffset: {
        width: 0,
        height: 5,
      },
      shadowOpacity: 0.34,
      shadowRadius: 6.27,
      elevation: 10,
    },
  };
};
